<template>
  <div>
    <v-layout wrap align-center>
      <v-flex xs9 :class="primary && ['title', 'sarabun', 'primary--text', 'font-weight-bold']">
        {{ $t('Send Purchase Signal from Shop Service to Meta Ads Manager') }}
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <div>
          <toggle-button
            :value="inActiveFbSendPurchase"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
            @change="toggleFbSendPurchase"
          />
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'

export default {
  components: { ToggleButton },
  props: {
    primary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inActiveFbSendPurchase: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  created() {
    this.inActiveFbSendPurchase = !this.selectedBot.is_not_send_event_purchase_to_facebook
  },
  methods: {
    async toggleFbSendPurchase({ value }) {
      const isSuccess = await this.$store.dispatch('updateFbPurchaseSetting', {
        page_id: this.selectedBot.pageid,
        is_not_send_event_purchase_to_facebook: !value
      })
      if (isSuccess) {
        this.inActiveFbSendPurchase = value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/billing/MetaPurchaseSignal.vue